import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { of, map } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';

const LEGAL_DISCLAIMER_EXCLUDE_COUNTRIES = ['IL', 'IN'];

@Component({
  selector: 'fin-copyright',
  template: `
    <ng-container>
      @let licenses = 'copyrightBanner.licensesHTML' | finLocalization;

      <p class="font-body-2 regular-type font-body-small">
        <span data-testid="copyright">{{ 'copyrightBanner.copyright' | finLocalization }} {{ year }}. </span>
        @if ((showDisclaimer$ | async) === true) {
          <span data-testid="legal-disclaimer">{{ 'copyrightBanner.legalDisclaimer' | finLocalization }}</span>
        }
      </p>
      @if (licenses !== '') {
        <span
          class="license font-body-1 nordic-blue-900-text text-icon-primary regular-type nowrap font-body-medium"
          data-testid="legal-licenses"
          [innerHTML]="licenses"
        ></span>
      }
    </ng-container>
  `,
  styleUrls: ['./copyright.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CopyrightComponent implements OnInit {
  private languageService = inject(LanguageService);

  showDisclaimer$ = of(true);
  year: number = new Date().getFullYear();

  ngOnInit(): void {
    this.showDisclaimer$ = this.languageService.countryCode.pipe(
      map((countryCode) => {
        return !LEGAL_DISCLAIMER_EXCLUDE_COUNTRIES.includes(countryCode);
      })
    );
  }
}
